import React, { PureComponent } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { getFormattedDates } from '../helper';
import { DATE_CHANGE } from '../../../Constants/constants';
import { bindActionCreators } from 'redux';
import { ExpandToggleButton, AddNewMilestone, EditMilestone } from './';
import { contentManagementAction } from '../../../reducers/contentMangementData';
import { subjectNameStyles, dateStyle, editCTC, disableEditCta, bullets, editBlock } from './weekStyles';
import { connect } from 'react-redux';
import _ from 'lodash';
import { showMsg } from '../../../../course/actions/loaderAlert';

interface WeekPhaseProps {
  weekPhaseData: any;
  handleExpandOnDrag: Function;
  handleExpandNode: Function;
  isExpanded: boolean;
  phaseAlignmentResponse: any;
  subjectTab: string;
  treeData: any;
  setTreeData: Function;
}

interface WeekPhaseState {
  enableEditting: boolean;
  isUpdate: boolean;
}

class WeekPhase extends PureComponent<WeekPhaseProps, WeekPhaseState> {
  constructor(props: WeekPhaseProps) {
    super(props);
    this.state = {
      enableEditting: false,
      isUpdate: false,
    };
  }

  getConceptCount = () => {
    let conceptCount = 0;
    const {treeData}=this.props;
    const showChapters=_.get(treeData,'displaySettings.showChapters',true);
    if (this.props.subjectTab === 'All Subjects') {
      try {
        if(showChapters){
         this.props.weekPhaseData.children.forEach((chapter: any) => 
             conceptCount += chapter.concepts.length);
        }else{
          conceptCount=this.props.weekPhaseData.children.length;
        }
      } catch (error) {}
    } else {
      try {
        this.props.weekPhaseData.children.forEach((chapter: any) => {
          if (this.props.subjectTab === chapter.subjectName) {
            if(showChapters){
              conceptCount += chapter.concepts.length;
            }else{
              conceptCount+=1;
            }
          }
        });
      } catch (error) {}
    }
    return conceptCount;
  };

  renderEdit = () => {
    this.setState({ enableEditting: !this.state.enableEditting });
  };

  getResponse = (response: boolean) => {
    this.setState({ isUpdate: response });
    this.setState({ isUpdate: false });
  };

  componentWillUnmount() {
    if (this.props.isExpanded) {
      this.props.handleExpandNode();
    }
  }

  render = () => {
    const { weekPhaseData, handleExpandNode, isExpanded, treeData } = this.props;
    const {displaySettings} = treeData;
    // const { handleExpandOnDrag } = this.props;
    const { name = '', startDate, endDate, weekIndex, phaseIndex, children, content,chapterContent,conceptContent } = weekPhaseData;
    const hasValidChildren = (children && children.length) || (content && content.length > 0) || chapterContent||conceptContent ;
    return (
      <>
        {weekIndex !== 0 ? <AddNewMilestone data={weekPhaseData} /> : <></>}
        <Droppable droppableId={`week-${phaseIndex}-${weekIndex}`}>
          {(provided, snapshot) => (
            <span ref={provided.innerRef} style={{ minHeight: '5vh' }}>
              {/* {snapshot.isDraggingOver && hasValidChildren && !isExpanded ? handleExpandOnDrag() : ''} */}

              <div>
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                  }}
                >
                  {hasValidChildren ? (
                    <ExpandToggleButton
                      handleClick={handleExpandNode}
                      isExpanded={isExpanded}
                      isBulkDataAdded={weekPhaseData.isBulkDataAdded}
                    />
                  ) : (
                    <></>
                  )}

                  <span style={subjectNameStyles}>{name}</span>
                  <span style={bullets}>&bull;</span>
                  <span style={dateStyle}>{getFormattedDates(startDate, endDate)}</span>
                  {displaySettings.showConcepts ?<span style={bullets}>&bull;</span>:''}
                  <span>
                    {displaySettings.showConcepts ? <span style={dateStyle}>{this.getConceptCount()} Concepts</span>: ''}
                    {weekPhaseData.isDisable ? (
                      <span style={disableEditCta}>
                        <img src='/assets/svg/editOutline.svg' alt='edit-icon' />
                      </span>
                    ) : (
                      <span onClick={this.renderEdit} style={editCTC}>
                        <img src='/assets/svg/editOutline.svg' alt='edit-icon' />
                      </span>
                    )}
                  </span>
                  <span style={editBlock}>
                    {this.state.enableEditting && (
                      <EditMilestone
                        confirmationFor={DATE_CHANGE}
                        editMiles={false}
                        parent={weekPhaseData}
                        close={this.renderEdit}
                      />
                    )}
                  </span>
                </span>
              </div>
              {provided.placeholder}
            </span>
          )}
        </Droppable>
      </>
    );
  };
}
const mapStateToProps = (state: any) => {
  return {
    treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setTreeData: contentManagementAction.setTreeData,
      showMsg: showMsg,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(WeekPhase);
